import { emptySplitApi } from '../../../../store/emptyApi';
import { RAGInstructionsApiTags } from './RAGInstructionsApiTags';
import { AIPromptApiTags } from './AIPromptApiTags';
import { PromptTestResult } from './aiPromptApi';

export interface RAGInstructions {
  id?: number;
  instructions_text: string;
  followup_instructions_text: string;
  updated_at?: string;
  updated_by?: number;
  version?: number;
}

export interface RAGTestRequest {
  test_message: string;
  instructions_text?: string;
  mock_rag_context?: string;
}

const taggedApi = emptySplitApi.enhanceEndpoints({
  addTagTypes: [...Object.values(RAGInstructionsApiTags), AIPromptApiTags.AIPromptEval],
});

const ragInstructionsApi = taggedApi.injectEndpoints({
  endpoints: (build) => ({
    getRAGInstructions: build.query<RAGInstructions, void>({
      query: () => ({
        url: '/api/admin/v1/rag-instructions/',
        method: 'GET',
      }),
      providesTags: [RAGInstructionsApiTags.RAGInstructions],
    }),
    updateRAGInstructions: build.mutation<RAGInstructions, { instructions_text: string; followup_instructions_text: string }>({
      query: (body) => ({
        url: '/api/admin/v1/rag-instructions/',
        method: 'PUT',
        body,
      }),
      invalidatesTags: [
        RAGInstructionsApiTags.RAGInstructions,
        // Saving bumps the version, so the latest chat eval turns stale
        { type: AIPromptApiTags.AIPromptEval, id: 'rag' },
      ],
    }),
    testRAGInstructions: build.mutation<PromptTestResult, RAGTestRequest>({
      query: (body) => ({
        url: '/api/admin/v1/rag-instructions/test/',
        method: 'POST',
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetRAGInstructionsQuery,
  useUpdateRAGInstructionsMutation,
  useTestRAGInstructionsMutation,
} = ragInstructionsApi;
export { ragInstructionsApi };
